import { SpiderIcon } from './SpiderIcon';

/**
 * author: Michael Richins
 * id BCDD4A6F-3064-4FF3-9172-0BBF8BED2D2C
 * name spider
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spider.svg
 * tags
 * - Holiday 
 * - Nature 
 * - Animal 
 */
export const ArachnidIcon = SpiderIcon;
export default ArachnidIcon